import React from "react";
import styled from "styled-components";
import { ReactComponent as BgSvg } from "images/svg/pricing-bg.svg";
import { ReactComponent as BgSvgMobile } from "images/svg/starfield-mobile.svg";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import SummaryCard from "./components/summary-card";
import { useLocation } from "react-router-dom";
import Navbar from "components/navbar/landingPage-navabar";
import Footer from "components/footer";

const PricingSummary = () => {
  const { isMonthly, ActivePackage } = useLocation().state;

  return (
    <Main>
      <Navbar />
      <Bg>
        <BgSvg />
      </Bg>
      <MBg>
        <BgSvgMobile width={"100%"} height={"100%"} />
      </MBg>
      <Container>
        <HeaderText>
          <Typography
            mt="6.4"
            align="center"
            size="3.6rem"
            weight="semibold"
            color={Colors.white100}
            m_size="4xl"
            m_mt="4.8"
          >
            Payment Summary
          </Typography>
          <Typography
            align="center"
            mt="1.6"
            m_mt="0.8"
            color={Colors.grey400}
            size="3xl"
            m_size="m"
          >
            Total your subscription and unlock unlimited distribution ,
            promotional tools, and full royalty ownership.
          </Typography>
        </HeaderText>
        <SummaryCard ActivePackage={ActivePackage} isMonthly={isMonthly} />
      </Container>
      <Footer />
    </Main>
  );
};

export default PricingSummary;

const Main = styled.main`
  width: 100%;
  background-color: #0d0d0d;
`;

const Container = styled.div`
  position: relative;
  @media only screen and (max-width: 769px) {
    padding: 0 2.4rem;
  }
`;

const Bg = styled.div`
  width: 100%;
  position: absolute;
  height: fit-content;
  left: -8.2%;
  /* top: -9%; */
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const MBg = styled.div`
  display: none;
  width: 100%;
  position: absolute;
  height: fit-content;

  @media only screen and (max-width: 769px) {
    display: block;
  }
`;
const HeaderText = styled.div`
  width: 44%;
  margin-left: auto;
  margin-right: auto;
  z-index: 5;
  position: relative;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
